import * as React from 'react';

import { Button } from './Button';
import { FeatherIconName } from './FeatherIconName';

interface Props
  extends React.DetailedHTMLProps<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > {
  children: React.ReactNode;
  loading?: boolean;
  icon?: FeatherIconName;
}

export const SubmitButton = ({ children, loading, ...restProps }: Props) => {
  return (
    <Button
      type="submit"
      {...restProps}
      disabled={loading || restProps.disabled}
    >
      {loading ? 'Loading...' : children}
    </Button>
  );
};
